import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eb9afc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-progress" }
const _hoisted_2 = {
  key: 0,
  class: "app-progress__message"
}
const _hoisted_3 = { class: "app-progress__bar bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        style: _normalizeStyle('width: ' + _ctx.percent + '%'),
        class: "bar__item"
      }, null, 4)
    ])
  ]))
}